import { render, staticRenderFns } from "./BuyArchive.vue?vue&type=template&id=68523350&"
import script from "./BuyArchive.vue?vue&type=script&lang=js&"
export * from "./BuyArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports